module.exports = __webpack_public_path__ + "img/opal.be5030ca.webp";